module.exports = __webpack_public_path__ + "img/PG.aae065c0.svg";